<template>
  <el-dialog
    modal-class="signing"
    fullscreen
    v-model="displaySigning">
    <div class="signing__body">
      <div v-if="loading" class="signing__body__loading">
        <loading-icon />
      </div>
      <iframe v-show="!loading"
              id="yousign-iframe"
              ref="yousignFrame"
              class="signing__body--iframe"></iframe>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useComparatorStore } from '@/stores';
import LoadingIcon from '@/utils/components/LoadingIcon.vue';

export default {
  name: 'SigningModal',
  components: {
    LoadingIcon,
  },
  data() {
    return {
      loading: true,
      sandbox: import.meta.env.VITE_APP_YOUSIGN_SANDBOX === 'true',
    };
  },
  computed: {
    ...mapState(useComparatorStore, ['isSigningModalDisplayed', 'offer']),
    displaySigning: {
      get() {
        return this.isSigningModalDisplayed;
      },
      set() {
        this.hideSigningModal();
      },
    },
    isYousignV3() {
      return this.offer?.signing_procedure?.version === 'v3';
    },
  },
  methods: {
    ...mapActions(useComparatorStore, ['hideSigningModal', 'activateSignature']),
    closeSigningWindow() {
      this.loading = false;
      this.displaySigning = false;
    },
    getSigningLink() {
      return this.offer?.signing_procedure?.signing_url;
    },
    showYousignIframe(yousignLink) {
      window.yousignApp = new window.Yousign({
        signatureLink: yousignLink,
        iframeContainerId: 'yousign-iframe',
        isSandbox: this.sandbox,
        iFrameAttributes: {
          referrerPolicy: 'origin-when-cross-origin',
        },
      });

      window.yousignApp.onError(this.closeSigningWindow);
      window.yousignApp.onDeclined(this.closeSigningWindow);
      window.yousignApp.onSuccess(() => {
        this.closeSigningWindow();
        this.$router.push({ name: 'redirect' }).catch(() => {});
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      const signingLink = this.getSigningLink();

      if (this.isYousignV3) {
        // Activate signature from backend
        this.activateSignature(this.offer)
          .then((data) => {
            this.loading = false;
            this.showYousignIframe(data.signing_url);
          })
          .catch(() => {
            this.loading = false;
            this.displaySigning = false;
          });
      } else {
        this.loading = false;
        if (this.$refs.yousignFrame) {
          this.$refs.yousignFrame.src = signingLink;
        }
      }
    });
  },
  beforeUnmount() {
    if (window.yousignApp) {
      window.yousignApp.removeMessageListener();
    }
  },
};
</script>

<style lang="scss" scoped>
.signing {
  &__body {
    height: calc(100vh - 90px);

    &--iframe {
      width: 100%;
      height: 100%;
    }

    &__loading {
      height: 85%;
      align-content: center;
      text-align: center;

      :deep(.loading-icon .bar) {
        background-color: var(--nxt-color-secondary);
      }
    }
  }
}
</style>
